export default __webpack_public_path__ + "static/media/logo-icon.e92605e5.svg";